import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BeautybookModule } from '@features/beautybook/beautybook.module';
import { ProductModule } from '@features/product/product.module';
import { FcDropdownModule } from '@shared/components/fc-dropdown/fc-dropdown.module';
import { SharedModule } from '@shared/shared.module';
import { SwiperModule } from 'swiper/angular';
import { UserDropdownComponent } from './components/user-dropdown/user-dropdown.component';
import { UserHappyPayBankAccountDialogComponent } from './components/user-happy-pay-bank-account-dialog/user-happy-pay-bank-account-dialog.component';
import { UserHappyPayTopupAddDialogComponent } from './components/user-happy-pay-topup-add-dialog/user-happy-pay-topup-add-dialog.component';
import { UserHappyPayWithdrawalAddDialogComponent } from './components/user-happy-pay-withdrawal-add-dialog/user-happy-pay-withdrawal-add-dialog.component';
import { UserSkinfitAnalyseDialogComponent } from './components/user-skinfit-analyse-dialog/user-skinfit-analyse-dialog.component';
import { UserBeautybookPostComponent } from './pages/user-beautybook-post/user-beautybook-post.component';
import { UserCheckoutComponent } from './pages/user-checkout/user-checkout.component';
import { UserDashboardComponent } from './pages/user-dashboard/user-dashboard.component';
import { UserHappyPayBankAccountComponent } from './pages/user-happy-pay/user-happy-pay-bank-account/user-happy-pay-bank-account.component';
import { UserHappyPayTopupComponent } from './pages/user-happy-pay/user-happy-pay-topup/user-happy-pay-topup.component';
import { UserHappyPayTransactionHistoryComponent } from './pages/user-happy-pay/user-happy-pay-transaction-history/user-happy-pay-transaction-history.component';
import { UserHappyPayWithdrawalComponent } from './pages/user-happy-pay/user-happy-pay-withdrawal/user-happy-pay-withdrawal.component';
import { UserHappyPayComponent } from './pages/user-happy-pay/user-happy-pay.component';
import { UserInvoiceComponent } from './pages/user-invoice/user-invoice.component';
import { UserOrderDetailComponent } from './pages/user-order/user-order-detail/user-order-detail.component';
import { UserOrderComponent } from './pages/user-order/user-order.component';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';
import { UserReviewComponent } from './pages/user-review/user-review.component';
import { UserSkinFitComponent } from './pages/user-skin-fit/user-skin-fit.component';
import { UserWishlistComponent } from './pages/user-wishlist/user-wishlist.component';
import { UserRoutingModule } from './user-routing.module';
import { UserComponent } from './user.component';
import { UserSkinFitNologinComponent } from './pages/user-skin-fit/user-skin-fit-nologin/user-skin-fit-nologin.component';
import { UserReviewProductPendingComponent } from './pages/user-review/user-review-product-pending/user-review-product-pending.component';
import { UserReviewProductHistoryComponent } from './pages/user-review/user-review-product-history/user-review-product-history.component';
import { UserReviewsImageDialogComponent } from './components/user-reviews-image-dialog/user-reviews-image-dialog.component';

@NgModule({
  declarations: [
    UserComponent,
    UserProfileComponent,
    UserDashboardComponent,
    UserCheckoutComponent,
    UserOrderComponent,
    UserHappyPayComponent,
    UserReviewComponent,
    UserBeautybookPostComponent,
    UserWishlistComponent,
    UserDropdownComponent,
    UserSkinfitAnalyseDialogComponent,
    UserSkinFitComponent,
    UserInvoiceComponent,
    UserOrderDetailComponent,
    UserHappyPayTopupAddDialogComponent,
    UserHappyPayWithdrawalAddDialogComponent,
    UserHappyPayWithdrawalComponent,
    UserHappyPayTopupComponent,
    UserHappyPayBankAccountComponent,
    UserHappyPayTransactionHistoryComponent,
    UserHappyPayBankAccountDialogComponent,
    UserReviewProductPendingComponent,
    UserReviewProductHistoryComponent,
    UserReviewsImageDialogComponent,
  ],
  imports: [
    CommonModule,
    UserRoutingModule,
    SharedModule,
    FcDropdownModule,
    ProductModule,
    SwiperModule,
    BeautybookModule,
  ],
  exports: [UserDropdownComponent],
})
export class UserModule {}
